module.exports = __webpack_public_path__ + "img/rectangular-enclamation-mark-red.34df6674.svg";